import { Link, useLocation } from "react-router-dom";
import { useEntitlements } from "./entitlements/EntitlementContext";
import { filterMsiOperatorItems } from "./msiOperatorAccess";

const globalTabs = [
  { label: "Sports", to: "/" },
  { label: "MSI", to: "/msi" },
  { label: "TEG", to: "/teg" },
];

const msiTabs = [
  { label: "Customer Today", to: "/msi" },
  { label: "Operator Dashboard", to: "/msi/operator", operator: true },
  { label: "Universe", to: "/msi/universe", operator: true },
  { label: "Calls", to: "/msi/universe?bias=CALL", operator: true },
  { label: "Puts", to: "/msi/universe?bias=PUT", operator: true },
  { label: "Watchlist", to: "/msi/watchlist", operator: true },
  { label: "Alerts", to: "/msi/alerts", operator: true },
  { label: "Positions", to: "/msi/positions", operator: true },
  { label: "Closed", to: "/msi/closed", operator: true },
  { label: "3D Reclaims", to: "/msi/universe?stage=3D_50MA_RECLAIM", operator: true },
  { label: "3D Attacks", to: "/msi/universe?stage=3D_50MA_ATTACK", operator: true },
];

const rowStyle = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  alignItems: "center",
};

const baseLinkStyle = {
  borderRadius: 10,
  textDecoration: "none",
  color: "#FFFFFF",
  fontWeight: 800,
};

export default function MSINav() {
  const location = useLocation();
  const entitlement = useEntitlements();
  const current = `${location.pathname}${location.search}`;

  const isGlobalActive = (to) => {
    if (to === "/") return location.pathname === "/";
    if (to === "/msi") return location.pathname.startsWith("/msi");
    if (to === "/teg") return location.pathname.startsWith("/teg");
    return false;
  };

  const isMsiActive = (to) => {
    if (to === "/msi") return location.pathname === "/msi" && !location.search;
    if (to.includes("?")) return current === to;
    return location.pathname === to;
  };

  return (
    <nav aria-label="PWG and MSI navigation" style={{ marginBottom: 20 }}>
      <div
        style={{
          ...rowStyle,
          justifyContent: "space-between",
          padding: "12px 14px",
          marginBottom: 12,
          background: "#111827",
          border: "1px solid #293548",
          borderRadius: 12,
        }}
      >
        <div style={{ color: "#A0A0A0", fontSize: 12, fontWeight: 900, letterSpacing: 1.1 }}>
          PLAYS WITH GURU
        </div>

        <div style={rowStyle}>
          {globalTabs.filter((tab) => (
            tab.to !== "/teg" || entitlement.applications?.TEG?.enabled === true
          )).map((tab) => {
            const active = isGlobalActive(tab.to);
            return (
              <Link
                key={tab.label}
                to={tab.to}
                aria-current={active ? "page" : undefined}
                style={{
                  ...baseLinkStyle,
                  padding: "9px 16px",
                  border: active ? "1px solid #38BDF8" : "1px solid #334155",
                  background: active ? "#0C4A6E" : "#172033",
                }}
              >
                {tab.label}
              </Link>
            );
          })}
        </div>
      </div>

      <div style={rowStyle}>
        {filterMsiOperatorItems(msiTabs, entitlement).map((tab) => {
          const active = isMsiActive(tab.to);
          return (
            <Link
              key={tab.label}
              to={tab.to}
              aria-current={active ? "page" : undefined}
              style={{
                ...baseLinkStyle,
                padding: "10px 18px",
                border: active ? "1px solid #3B82F6" : "1px solid #2A2A2A",
                background: active ? "#2563EB" : "#171717",
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
